module.exports = __webpack_public_path__ + "media/newstyle/images/cta-mobile-072a93acf8c5decfb9d87097deae4d71.png";